import React from "react";

const DigitalTimer = ({ seconds }) => {
  const value = seconds < 10 ? `0:${seconds}` : `0:${seconds}`;

  return (
    <span
      className="
        inline-flex
        items-center
        justify-center
        px-2
        py-[2px]
        rounded-md
        font-mono
        text-xl
        tracking-wider
        text-orange-400
        bg-[#0e3b46]
        border
        border-[#1e5f6f]
        drop-shadow-[0_0_3px_rgba(255,165,0,0.55)]
      "
    >
      {value}
    </span>
  );
};

export default DigitalTimer;
